import {
  WechatContact,
  WechatFriendApplyData,
  WechatRoom,
} from "@packages/chat-sdk";
import { Store } from "./store";
export interface WechatContactsStoreType {
  selectedContactOrRoom?: WechatContact | WechatRoom | WechatFriendApplyData;
}

export const wechatContactsStore = new Store<WechatContactsStoreType>(() => ({
  selectedContactOrRoom: undefined,
}));
export const wechatContactsStoreActions = {
  setSelectedContactOrRoom(
    payload?: WechatContact | WechatRoom | WechatFriendApplyData
  ) {
    wechatContactsStore.set({
      selectedContactOrRoom: payload,
    });
  },
};
